"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AbstractInitializer_1 = __importDefault(require("../AbstractInitializer"));
const asyncIterate_1 = __importDefault(require("../../../../Util/asyncIterate"));
class CustomerPeriodInitializer extends AbstractInitializer_1.default {
    constructor(cache, customerRepository, customerPeriodModel) {
        super("customer_period_initializer", cache);
        this.initialize = async () => {
            await (0, asyncIterate_1.default)(await this.customerRepository.getCustomers(), ({ id, subscriptionPeriod, plan, trainingLocation }) => {
                return this.customerPeriodModel.setPeriods([
                    {
                        ...subscriptionPeriod,
                        duration: 6,
                        end: subscriptionPeriod.endDate,
                        start: subscriptionPeriod.startDate,
                        plan: { name: plan.name },
                        subscriptionType: subscriptionPeriod.periodType,
                        trainingLocation: {
                            details: trainingLocation.gymName,
                            placeName: trainingLocation.placeName,
                        },
                        coach: null,
                        coachingDays: subscriptionPeriod.coachingDays,
                    },
                ], id);
            });
        };
        this.customerRepository = customerRepository;
        this.customerPeriodModel = customerPeriodModel;
    }
}
exports.default = CustomerPeriodInitializer;
//# sourceMappingURL=CustomerPeriodInitializer.js.map